const CATALOG_SKUS = new Set([
  '10AM', '5am-60', 'AE1', 'ACTH', 'AR100', 'AR50', 'AD10', 'AD2', 'AD5', 'RA10',
  'ADW10', 'ADW3', 'AX10', 'APE10', 'APE2', 'APE5', '33B10', 'BB20', 'BC10', 'BC2',
  'BC5', 'BB30', 'BB10', 'bpc-100', 'WA10', 'WA3', 'CP10', 'CND10', 'CND2', 'CND5',
  'CD2', 'CD5', 'CGL10', 'CGL5', 'CS20', 'CS5', 'CS10', 'CARD', 'CORT', 'CRYS',
  'DS2', 'DS5', 'DR10', 'ET10', 'ET50', 'F410', 'F42', 'FOXO4D', 'FN1', 'FRA23',
  'GF1', 'CU100', 'CU50', 'G210', 'G215', 'G25', 'G610', 'G65', 'BBG70', 'GT600',
  'GTT', 'GND2', 'GND5', 'G10K', 'G2K', 'G5K', 'H06', 'H08', 'H10', 'H12',
  'H15', 'H24', 'FR1', 'FR10', 'FR2', 'FR5', 'G75', 'HX2', 'HX5', 'HM10',
  'IG01', 'IG1', 'IP10', 'IP2', 'IP5', 'KLOW', 'KPV10', 'KPV5', 'kp-60', 'KS10',
  'KS5', 'LC500', 'LDG-100', '2L5', 'LB', 'lipo-c', 'LGE10', 'LGE5', 'FM2', 'MK-100',
  'MS10', 'MS40', 'MATR', 'MDT', 'MT1', 'ML10', 'NJ100', 'NJ1K', 'NJ500', 'NJ1KJ',
  'OREX', 'OT10', 'OT2', 'OT5', 'P21', 'PE28', 'FMP2', 'P27', 'P41', 'PIN5',
  'PN10', 'RT10', 'RT15', 'RT20', 'RT30', 'RT5', 'RT50', 'slp-100', 'slp-500', '2S10',
  '2S50', 'SK10', 'SK5', 'SM10', 'SM15', 'SM2', 'SM20', 'SM5', 'SM50', 'XA10',
  'XA5', 'SMO10', 'SMO15', 'SMO2', 'SMO5', 'NP810', 'BT10', 'BT2', 'BT5', 'TSM10',
  'TSM2', 'TSM20', 'TSM5', 'teso-100', 'TN10', 'TA10', 'TA5', 'T10', 'T100', 'T15',
  'T20', 'T30', 'T40', 'T5', 'T50', 'T60', 'TPA', 'VIP10', 'VIP5',
  'GHKCU + KPV', 'SK10+XA10', 'TI-13/3',
]);

const CAPSULE_BOTTLE_SKUS = new Set([
  '5am-60', 'bpc-100', 'kp-60', 'LDG-100', 'MK-100', 'slp-100', 'slp-500', 'teso-100',
]);

const THREE_ML_LIQUID_SKUS = new Set(['ADW3', 'WA3']);
const TEN_ML_LIQUID_SKUS = new Set(['ADW10', 'WA10', 'LC500', 'LB', 'lipo-c']);

const ARTWORK = {
  standard: {
    key: 'standard-powder-vials',
    assetPath: '/images/products/batchtrue-ten-powder-vials.png',
    container: 'standard vial',
    capacityMl: null,
    fill: 'powder',
  },
  liquid3: {
    key: 'liquid-vials-3ml',
    assetPath: '/images/products/batchtrue-ten-liquid-vials-3ml.png',
    container: '3 mL vial',
    capacityMl: 3,
    fill: 'clear liquid',
  },
  liquid10: {
    key: 'liquid-vials-10ml',
    assetPath: '/images/products/batchtrue-ten-liquid-vials-10ml.png',
    container: '10 mL vial',
    capacityMl: 10,
    fill: 'clear liquid',
  },
  capsules: {
    key: 'capsule-bottle',
    assetPath: '/images/products/batchtrue-capsule-bottle.png',
    container: 'screw-cap bottle',
    capacityMl: null,
    fill: 'capsules',
  },
  unknown: {
    key: 'unknown',
    assetPath: null,
    container: null,
    capacityMl: null,
    fill: null,
  },
};

export function productArtwork(product = {}) {
  const sku = String(product.sku || '').trim();
  if (!CATALOG_SKUS.has(sku)) return ARTWORK.unknown;
  if (CAPSULE_BOTTLE_SKUS.has(sku)) return ARTWORK.capsules;
  if (THREE_ML_LIQUID_SKUS.has(sku)) return ARTWORK.liquid3;
  if (TEN_ML_LIQUID_SKUS.has(sku)) return ARTWORK.liquid10;
  return ARTWORK.standard;
}

export const productArtworkCatalogSize = CATALOG_SKUS.size;
